import { FaFileAlt, FaUserCog, FaUserTie, FaUsers, FaVoteYea } from 'react-icons/fa';

import { DefaultPageSection } from '../../components';
import { FunctionComponent } from 'react';
import { PaginaInicialTimelineItem } from '.';
import { PaginaInicialTimelineType } from '../../types';
import { useTranslation } from 'react-i18next';

const PaginaInicialTimeline: FunctionComponent<PaginaInicialTimelineType> = ({ id = 'timeline' }) => {
  const { t } = useTranslation();
  return (
    <DefaultPageSection
      heading={t('label.passos_sistema_cadastramento')}
      subheading={t('texto.passos_sistema_cadastramento')}
      id={id}
      full
      bgWhite
    >
      <ul className="timeline">
        <PaginaInicialTimelineItem
          stepIcon={FaFileAlt}
          stepNumber={1}
          heading={t('label.dados_eleicao')}
          description={t('texto.cadastro_dados_gerais_eleicao')}
        />
        <PaginaInicialTimelineItem
          stepIcon={FaUserCog}
          stepNumber={2}
          heading={t('label.comissao_eleitoral')}
          description={t('texto.cadastro_membros_comissao')}
        />
        <PaginaInicialTimelineItem
          stepIcon={FaUserTie}
          stepNumber={3}
          heading={t('label.cargos_candidaturas')}
          description={t('texto.cadastro_cargos_candidaturas')}
        />
        <PaginaInicialTimelineItem
          stepIcon={FaUsers}
          stepNumber={4}
          heading={t('label.grupos_eleitores')}
          description={t('texto.cadastro_grupo_eleitores')}
        />
        <PaginaInicialTimelineItem
          stepIcon={FaVoteYea}
          stepNumber={5}
          heading={t('label.publicacao_eleicao')}
          description={
            <>
              {t('texto.eleicao_publicada')}
              <a href="https://sigeleicao.ufpb.br" className="text-muted" target="_blank" rel="noreferrer">{`${t(
                'label.sigeleicao',
              )}.`}</a>
            </>
          }
        />
      </ul>
    </DefaultPageSection>
  );
};

export default PaginaInicialTimeline;
